export const APPROVESELLER = "Approved";
export const REJECTSELLER = "Rejected";
export const PLACEONHOLD = "On Hold";
export const RESENDACTIVATIONDETAIL = "Resend Activation Details";
export const ONBOARDING = "Onboarding";
export const BUILDING = "Building";
export const CERTIFIED = "Certified";
export const APPROVESUBSELLER = "Approved";
export const REJECTSUBSELLER = "Rejected";
export const PENDINGAPPROVESELLER = "Pending Approval"


export const STATUSES = {
  "PR": [PENDINGAPPROVESELLER, APPROVESELLER, REJECTSELLER, PLACEONHOLD],
  "APA": [APPROVESELLER, REJECTSELLER, PLACEONHOLD],
  "AE": [APPROVESELLER, REJECTSELLER, PLACEONHOLD],
  "RJ": [REJECTSELLER, APPROVESELLER, PLACEONHOLD],
  "OH": [PLACEONHOLD, APPROVESELLER, REJECTSELLER],
  "OB": [ONBOARDING, BUILDING, CERTIFIED],
  "BI": [BUILDING, CERTIFIED],
};

export const SUBSELLERSTATUSES = {
  "Pending Approval": [APPROVESELLER, REJECTSELLER],
};

export const STATUSBUTTONS = {
  "Pending Approval": [APPROVESELLER],
  "Pending Activation": [REJECTSELLER, PLACEONHOLD],
  "Expired Activation": [REJECTSELLER, PLACEONHOLD],
  "Rejected Sellers": [REJECTSELLER],
  "On Hold": [PLACEONHOLD],
};

export const STATUSMAPPING = {
  "Pending Activation": "Pending Activation",
  "Expired Activation": "Expired Activation",
  "Pending Approval": "Pending Approval",
  "Rejected Sellers": "Rejected",
  "On Hold": "On hold",
  Onboarding: "Onboarding",
  Building: "Building",
  Certified: "Certified",
};

export const STATUSSUBSELLERMAPPING = {
  SSS001: "Pending Approval",
  SSS002: "Approved",
  SSS003: "Rejected",
};

export const REGISTEREDSELLERMAPPING = ["RALL", "PR", "OH", "APA", "AE", "RJ"];

export const ACTIVESELLERMAPPING = ["AALL", "OB", "BI", "CE"];

export const REQUIREDROLES = ["AC-Admin", "Super-Admin", "IT-Admin","Business-Admin","Business-User","Support-Admin","Support-User"];

export const ROLES = {
  IT_ADMIN: "IT-Admin",
  SUPER_ADMIN: "Super-Admin",
  BUSINESS_ADMIN: "Business-Admin",
  BUSINESS_USER: "Business-User",
};
export const CHECKROLE = {
  SUPPORT_ADMIN: "Support-Admin",
  SUPPORT_USER: "Support-User",
}

export const QUESTIONNARIEMAPPING = [
  "QUES001",
  "QUES002",
  "QUES003",
  "QUES004",
  "QUES005",
  "QUES006",
  "SUBQ001",
  "SUBQ002",
  "QUES007",
  "QUES008",
];

export const defaultLanguage = {
  en: "en",
};

export const COUNTRY_NAMES = {
  'CA': 'Canada',
  'FR': 'France',
  'FI': 'Finland',
  'JP': 'Japan',
  'IT': 'Italy',
  'US': 'United States of America',
  'UK': 'United Kingdom',
  'GB': 'United Kingdom',
  'DE': 'Germany',
  'ES': 'Spain',
  'AU': 'Australia',
  'IN': 'India',
  'BR': 'Brazil',
  'MX': 'Mexico',
  'NL': 'Netherlands',
  'BE': 'Belgium',
  'CH': 'Switzerland',
  'SE': 'Sweden',
  'NO': 'Norway',
  'DK': 'Denmark',
  'HK': 'Hong Kong',
  'IE': 'Ireland',
  'IL': 'Israel',
  'OT': 'Other',
  'TW': 'Taiwan',
};

export const BUSINESS_MODEL_MAP = {
  "OB": "Online booking tool",
  "OTA": "Online Travel Agency",
  "TO": "Tour Operator",
  "TP": "Technology provider",
  "CB" :"Corporate booking tool",
  "CO": "Consolidator",
  "AG": "Travel Agency",
  "MS": "Metasearch tool",
};

export const COMPANY_TYPE_MAP = {
  "AG": "Agency",
  "ALL": "All",
  "CO": "Corporate",
  "CR": "Consumer"
};

export const SUPPORT_FLOW_MAP = {
  "SF001": "Prime Booking",
  "SF002": "Post Booking",
  "SF003": "All"
};
